<template>
  <div ref="secondarySwiper" v-swiper="swiperOption" @click="clickHandler($event)">
    <div class="swiper-wrapper">
      <slot />
    </div>
  </div>
</template>

<script>
import { directive } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

export default {
  directives: {
    swiper: directive
  },

  data() {
    return {
      swiperOption: {
        watchOverflow: true,
        simulateTouch: false,
        slidesPerView: 'auto',
        spaceBetween: 24,
        speed: 3000,
        loop: true,
        loopedSlides: 10,
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        }
      }
    };
  },
  computed: {
    swiper() {
      return this.$refs.secondarySwiper.swiper;
    }
  },
  methods: {
    clickHandler(event) {
      const mainSwipe = document.querySelectorAll('.homepage-testimonials-slider')[1],
            section = document.getElementById('main-swiper'),
            eventTarget = event.target;
      
      let clickedSlide;
  
      if (eventTarget.classList.contains('swiper-slide')) {
        clickedSlide = eventTarget.getAttribute('data-swiper-slide-index');
      }
      else {
        clickedSlide = eventTarget.offsetParent.getAttribute('data-swiper-slide-index');
      }
    
      section.scrollIntoView();
      mainSwipe.swiper.slideToLoop(clickedSlide, 500, true);
    }
  }
};
</script>
